import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import StsA360RegStep1AnswerModel from '../../../models/sts-a360-reg-step1-answer.model';
import StsA360RegStep1AnswersModel from '../../../models/sts-a360-reg-step1-answers.model';
import StsA360RegStep1QuestionsModel from '../../../models/sts-a360-reg-step1-questions.model';
import StsA360RegistrationResponseModel from '../../../models/sts-a360-registration-response.model';
import { StsBooleanResultModel } from '../../../models/sts-boolean-result.model';
import { StsNotification } from '../../../models/sts-notification.model';
import { StsRegexBluePrintModel } from '../../../models/sts-regex-blue-print.model';
import { StsRegistrationType } from '../../../models/sts-registration-type.enum';
import { StsA360RegServicesService } from '../../../services/sts-a360-reg-services.service';
import { StsCaptchaComponent } from '../sts-captcha/sts-captcha.component';
import { StsCaptcha } from 'app/models/sts-captcha.model';

@Component({
  selector: 'app-sts-self-identifiers',
  templateUrl: './sts-self-identifiers.component.html',
  styleUrls: ['./sts-self-identifiers.component.scss']
})
export class StsSelfIdentifiersComponent implements OnInit {

  protected triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  questions: StsA360RegStep1QuestionsModel[];
  registrationModel: StsA360RegStep1AnswersModel;
  states: any = {};
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(StsCaptchaComponent) captcha: StsCaptchaComponent;

  @Input('mode') mode: StsRegistrationType;
  @Output('onSuccess') onSuccess = new EventEmitter<StsA360RegistrationResponseModel>(false);
  @Output('onErrors') onErrors = new EventEmitter<StsNotification[]>(false);
  @Output('onCancel') onCancel = new EventEmitter<StsRegistrationType>(false);

  constructor(
              private regService: StsA360RegServicesService) {
    this.registrationModel = new StsA360RegStep1AnswersModel();

  }

  ngOnInit() {
    this.registrationModel.answers = [];
    this.registrationModel.mode = this.mode;
    this.registrationModel.captcha = {};
    this.regService.getStep1Questions().subscribe(a => {
      this.questions = a;
      for (let i = 0; i < this.questions.length; i++) {
        let tmp = new StsA360RegStep1AnswerModel();
        tmp.question = this.questions[i];
        this.registrationModel.answers.push(tmp);
      }
    });
  }

  checkValidate(rs: StsBooleanResultModel) {
    if (!rs.result && !rs.value) {
      // console.log(rs);
      this.states[rs.model['questionID']] = rs.model['requiredValidationMessage'];
    } else if (!rs.result) {
      this.states[rs.model['questionID']] = rs.model['inputRegExpValidationMessage'];
    } else if (this.states.hasOwnProperty(rs.model['questionID'])) {
      delete this.states[rs.model['questionID']];
    }
  }

  getReType(t: StsA360RegStep1QuestionsModel): StsRegexBluePrintModel {
    let tmp = new StsRegexBluePrintModel();
    tmp.regexp = new RegExp(t.checkInputRegExp);
    tmp.model = t;
    return tmp;
  }

  onSubmit(captcha: StsCaptcha): void {
    this.triggerValidateEmitter.emit(null);
    this.submitter.emit(false );

    if (captcha) {
      let rsp = this.captcha.checkForCaptchaError(captcha);
      if (rsp != null) {
        this.onErrors.emit([rsp]);
        this.validateFields();
        this.captcha.reset();
        return;
      }
    }

    if (!this.validateFields()) {
      this.captcha.reset();
      return;
    }

    this.submitter.emit(true );
    this.registrationModel.captcha = captcha;
    this.regService.postStep1Answers(this.registrationModel).subscribe(
      r => {
        this.submitter.emit(false );
        this.onSuccess.emit(r);

        if (!r.success) {
          this.captcha.reset();
        }
      },
      errorRes => {
        this.captcha.reset();
      }
    );
  }

  public cancel(): void {
    this.onCancel.emit(this.mode);
  }



  private validateFields() {
    let k = 0;
    for (let i in this.states) {
      k++;
      if (this.states[i]) {
        return false;
      }
    }
    return k === 0 && this.questions.length > 0;
  }

  // private handleError(data) {
  //   let err = new StsNotification();
  //   err.code = data.stsCode || "sts-signup-1-error-message";
  //   err.description = data.message || data.stsCode || 'Error';
  //   err.level = StsNotificationType.Error;
  //   this.errors.push(err);
  //   this.recaptcha.reset();
  // }
  //
  // private mapError(data): StsErrorResponse {
  //   let response = new StsErrorResponse();
  //   response.message = data.message;
  //   response.status = data.status;
  //   response.stsCode = data['sts-code'];
  //   return response;
  // }


}
